'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'chess-bishop-piece';
var width = 320;
var height = 512;
var aliases = ["chess-bishop-alt"];
var unicode = 'f43b';
var svgPathData = 'M96 288L80.8 275c-25.9-22.2-40.8-54.6-40.8-88.7 0-27.3 9.6-53.8 27.1-74.8L120 48 112 48C98.7 48 88 37.3 88 24S98.7 0 112 0l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 31.8 38.2-64.8 64.8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l61-61c11.7 18.6 18 40.2 18 62.3 0 34.1-14.9 66.5-40.8 88.7l-15.2 13 16 96 56.2 70.3c5 6.3 7.8 14.1 7.8 22.2 0 19.6-15.9 35.5-35.5 35.5L51.5 512c-19.6 0-35.5-15.9-35.5-35.5 0-8.1 2.7-15.9 7.8-22.2L80 384 96 288z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessBishopPiece = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;